import { PostAdPageType } from '../get-data';

export const MAZUMA_OFF_VARIANT = 'A';
export const MAZUMA_OPTIONS_VARIANT = 'B';
export const MAZUMA_BANNER_VARIANT = 'C';

export const canSeeMazumaOptions = (
    mazumaFeatureValue: string,
    isOnAiCollectPage: boolean,
    postAdPageType: PostAdPageType,
    l3CategoryId?: number,
    l4CategoryId?: number
): boolean => {
    return (
        mazumaFeatureValue === MAZUMA_OPTIONS_VARIANT &&
        canSeeMazuma(
            mazumaFeatureValue,
            isOnAiCollectPage,
            postAdPageType,
            l3CategoryId,
            l4CategoryId
        )
    );
};

export const canSeeMazuma = (
    mazumaFeatureValue: string,
    isOnAiCollectPage: boolean,
    postAdPageType: PostAdPageType,
    l3CategoryId?: number,
    l4CategoryId?: number
): boolean => {
    const whitelistedL3Categories = [
        2487, // Computers, Laptops & Netbooks
        10956, // Consoles
        716, // Other Video Games & Consoles
        8679, // Smart Watch
        4660, // Mobile Phones
    ];

    const whitelistedL4Categories = [
        702, // Apple Laptops
        10548, // Tablets, eBooks & eReaders
    ];

    if (
        (postAdPageType !== 'create' && !isOnAiCollectPage) ||
        mazumaFeatureValue === MAZUMA_OFF_VARIANT
    ) {
        return false;
    }

    return (
        whitelistedL3Categories.includes(l3CategoryId!) &&
        (l3CategoryId !== 2487 || whitelistedL4Categories.includes(l4CategoryId!))
    );
};

export const getPanelTitle = (l3CategoryId?: number, l4CategoryId?: number): string => {
    if (l3CategoryId === 2487 && l4CategoryId === 702) {
        return 'How do you want to sell your laptop?';
    } else if (l3CategoryId === 2487 && l4CategoryId === 10548) {
        return 'How do you want to sell your tablet?';
    } else if (l3CategoryId === 10956 || l3CategoryId === 716) {
        return 'How do you want to sell your game console?';
    } else if (l3CategoryId === 8679) {
        return 'How do you want to sell your smart watch?';
    } else if (l3CategoryId === 4660) {
        return 'How do you want to sell your phone?';
    }
    return '';
};

export const getClickOutUrl = (l3CategoryId?: number, l4CategoryId?: number): string => {
    if (l3CategoryId === 2487 && l4CategoryId === 702) {
        // Sell My Mac Page
        return 'https://www.mazumamobile.com/affiliate?uid=3-bc4b0e81-6a16-4d35-9e5e-0f2c97fdca05&utm_source=affiliates&utm_medium=referral&utm_campaign=GumTree&utm_id=GumTree';
    } else if (l3CategoryId === 2487 && l4CategoryId === 10548) {
        // Sell My Tablet Page
        return 'https://www.mazumamobile.com/affiliate?uid=3-ba346f7f-2dfe-4334-afbc-dea7668040bf&utm_source=affiliates&utm_medium=referral&utm_campaign=GumTree&utm_id=GumTree';
    } else if (l3CategoryId === 10956 || l3CategoryId === 716) {
        // Sell My Console Page
        return 'https://www.mazumamobile.com/affiliate?uid=3-10c3b2eb-cf78-4525-8592-2a829e6a21d5&utm_source=affiliates&utm_medium=referral&utm_campaign=GumTree&utm_id=GumTree';
    } else if (l3CategoryId === 8679) {
        // Sell My Watch Page
        return 'https://www.mazumamobile.com/affiliate?uid=3-3e8bb66d-7949-4b51-937d-2c8c3d206e6a&utm_source=affiliates&utm_medium=referral&utm_campaign=GumTree&utm_id=GumTree';
    } else if (l3CategoryId === 4660) {
        // Sell My Mobile Page
        return 'https://www.mazumamobile.com/affiliate?uid=3-e71897f7-e3fa-430b-b780-abcb7b604aef&utm_source=affiliates&utm_medium=referral&utm_campaign=GumTree&utm_id=GumTree';
    }
    return '';
};
